<div class="flex flex-col bg-white comic-book">
  <!-- Section 1/1 -->

  <div
    *ngIf="authCredentials$ | async; else login"
    class="rotate flex flex-wrap min-h-screen background-green relative border-4 border-black mt-20 md:mt-2"
  >
    <span class="absolute w-2/4 right-0 top-0 h-full halftone top-right"></span>

    <span
      class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left ht-dark"
    ></span>

    <div class="absolute bottom-0 end-0 z-20">
      <div
        class="from-purple-700 via-purple-700 to-purple-800/30 read-more bg-gradient-to-l"
        style="padding-right: 6rem"
      >
        <a
          href="#"
          (click)="signOut()"
          class="font-bangers text-4xl md:text-6xl pr-2 text-white"
          data-text="Study Heroes puts Education, Teachers and Students first."
          >Sign Out</a
        >
      </div>
    </div>

    <div
      class="straighten w-full md:w-1/2 p-4 flex items-center z-20"
      *ngIf="profile$ | async as profile"
    >
      <div class="p-4">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
          >
            {{ profile?.name || 'Set Your Name' }}</span
          >
        </h2>
        <h3
          class="text-3xl font-semibold tracking-tight select-none mb-2 text-gray-900"
          *ngIf="
            profile?.firstName &&
            profile?.lastName &&
            profile?.name !== profile?.firstName + ' ' + profile?.lastName
          "
        >
          {{ profile.firstName }} {{ profile.lastName }}
        </h3>
        <h3
          class="text-3xl font-semibold tracking-tight select-none mb-2 text-gray-900"
        >
          {{ profile.email }}
        </h3>
        <p
          class="mt-6 text-2xl md:3xl text-green-100"
          *ngFor="let role of profile.roles"
        >
          {{ role.name }}
        </p>
        <p class="mt-6 text-2xl md:3xl text-green-100">
          {{ profile.details }}
        </p>
      </div>
    </div>
    <div class="w-full md:w-1/2 p-4 z-20">
      <div class="p-4">
        <img
          src="assets/images/avatars/batguy.webp"
          alt="Placeholder"
          class="h-auto shadow-md border-8 border-white"
        />
      </div>
    </div>
  </div>
</div>

<ng-template #login>
  <div
    class="title-header md:-top-16 flex flex-wrap min-h-screen background-blue relative border-4 border-black pb-10"
  >
    <div
      class="absolute bottom-0 bg-white right-20 z-50 w-full px-3.5 pb-2 h-auto"
    >
      <img
        src="/assets/images/artwork/vector-join.png"
        alt="Placeholder"
        class="absolute right-0 bottom-0 z-50 w-96 pointer-events-none"
      />

      <p
        class="font-bangers absolute right-44 w-40 z-50 text-black -top-48 text-center"
      >
        Time to level up our education!
      </p>
    </div>

    <span class="absolute w-1/4 right-0 h-full halftone top-right"></span>
    <span
      class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
    ></span>

    <!-- <div
    class="straighten text-container absolute top-24 w-full text-center z-10 p-4 bg-slate-900/90"
  >
    <span
      class="font-lexend text-2xl text-white pr-2 tracking-tighter border-1 border-solid rounded-full p-2 border-white"
      data-text="Study Heroes puts Education, Teachers and Students first."
      >Study Heroes puts Education, Teachers and Students first.</span
    >
  </div> -->

    <div
      class="straighten w-full md:w-1/1 p-4 flex items-center justify-center"
    >
      <div class="p-8 md:p-8 w-full text-center relative -top-8">
        <!-- <div
        class="border mb-2 text-xs text-center border-white/80 px-3.5 py-2 rounded-full text-white"
      >
        Study Heroes puts education, teachers and students first.
        <a href="#" class="ml-4 font-semibold leading-6 text-gray-900"
          >Learn more <span aria-hidden="true">→</span></a
        >
      </div> -->

        <div class="hero mt-6">
          <div class="hero-content flex-col lg:flex-row-reverse">
            <div class="text-center lg:text-left max-w-sm">
              <h2 class="text-container">
                <span
                  class="text text-flat font-bangers text-4xl md:text-6xl pr-2 bg-gradient-to-r from-blue-950 via-blue-700 to-blue-900"
                  >Suit Up!</span
                >
              </h2>

              <p class="mt-6 text-xl text-white">
                Welcome,
                <span class="bg-red-600 font-extrabold p-1 text-2xl"
                  >Hero!</span
                >
                We've been eagerly awaiting your arrival. Let's get you signed
                in and ready to save the day with our powerful learning tools!
              </p>
            </div>
            <div class="max-w-sm">
              <div
                class="card flex-shrink-0 w-full shadow-2xl bg-base-100 border-t-4 border-t-red-600 dark:border-t-yellow-200"
              >
                <div class="card-body">
                  <form [formGroup]="loginForm" (ngSubmit)="signInWithEmail()">
                    <div class="form-control">
                      <label class="label font-bangers" for="login-email">
                        <span class="label-text">Email</span>
                      </label>
                      <input
                        type="email"
                        autocomplete="email"
                        id="login-email"
                        class="input input-bordered text-black"
                        formControlName="email"
                      />
                      <p *ngIf="loginForm.controls.email.invalid && loginForm.controls.email.touched" class="mt-1 text-sm text-error" role="alert">Enter a valid email address.</p>
                    </div>
                    <div class="form-control">
                      <label class="label font-bangers" for="login-password">
                        <span class="label-text">Password</span>
                      </label>
                      <input
                        type="password"
                        autocomplete="current-password"
                        id="login-password"
                        class="input input-bordered text-black"
                        formControlName="password"
                      />
                      <p *ngIf="loginForm.controls.password.invalid && loginForm.controls.password.touched" class="mt-1 text-sm text-error" role="alert">Enter your password.</p>
                      <label class="label">
                        <a
                          href=""
                          (click)="$event.preventDefault(); resetPassword()"
                          class="label-text-alt link link-hover font-bangers"
                          >Forgot password?</a
                        >
                      </label>
                    </div>

                    <!-- <p class="alert alert-warning shadow-lg">err</p> -->

                    <div class="form-control mt-6">
                      <button
                        class="mt-3 btn btn-fast btn-primary font-bold py-2 px-4 ease-in-out duration-150 focus:outline-none focus:shadow-outline"
                        type="submit"
                        [disabled]="isSubmitting"
                      >
                        {{ isSubmitting ? 'Signing In...' : 'Sign In' }}
                      </button>
                    </div>
                  </form>

                  <button
                    (click)="signInWithGoogle()"
                    class="mt-3 btn btn-fast btn-primary font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    type="button"
                    [disabled]="isSubmitting"
                  >
                    Sign In With Google
                  </button>
                </div>
              </div>

              <p class="text-accent p-3 text-center font-oswald">
                Don&lsquo;t have an account?
                <a
                  class="font-extrabold font-oswald hover:text-primary"
                  routerLink="/signup"
                  >Sign Up</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
